/** File format for a downloaded pivot matrix. */
export enum PivotExportFormatEnum {
  Xlsx = 'xlsx',
  Csv = 'csv',
}
